//#region IMPORTS
import {
  backorderItemsSelectors,
  fetchBackorderItemsAsync,
} from "./backOrderSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { Fragment, useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { openModal } from "../dashBoard/dashboardSlice";
import {
  CROSS_BASKET_BLOCK,
  CROSS_PROMO_BLOCK,
} from "../../models/_consts";
import { Promo } from "../../models/promo";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import ItemContainer from "../../components/itemsGrid/ItemContainer";
import PageHeader from "../../components/genericPageHeader/PageHeader";
import agent from "../../api/agent";
//#endregion

export default function BackOrderPage() {
  //#region SETUP
  // Params
  const { id } = useParams<{ id: string }>();

  // Translation
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { basket } = useAppSelector((state) => state.basket);
  const instoreBasketActive = useAppSelector(
    (state) => state.instoreBasket.items.length > 0
  );
  const { backOrder_loaded, promo_id, order_code, status } = useAppSelector(
    (state) => state.backOrderItems
  );
  const backOrderItems = useAppSelector(backorderItemsSelectors.selectAll);

  // Local state
  const [promo, setPromo] = useState<Promo>();
  //#endregion

  const crossPromoBlocked =
    !!basket && basket.promo_id !== parseInt(id);

  //#region LOGIC
  // Open cross-basket modal when the instore basket blocks this page
  useEffect(() => {
    if (instoreBasketActive) {
      dispatch(openModal(CROSS_BASKET_BLOCK));
    }
  }, [instoreBasketActive, dispatch]);

  // Open cross-promo modal when another promo's basket is active
  useEffect(() => {
    if (crossPromoBlocked) {
      dispatch(openModal(CROSS_PROMO_BLOCK));
    }
  }, [crossPromoBlocked, dispatch]);

  // Fetch backorderables
  useEffect(() => {
    if (instoreBasketActive || crossPromoBlocked) return;
    if (!backOrder_loaded || promo_id !== parseInt(id)) {
      dispatch(fetchBackorderItemsAsync(parseInt(id)));
    }
  }, [
    backOrder_loaded,
    basket,
    dispatch,
    id,
    promo_id,
    instoreBasketActive,
    crossPromoBlocked,
  ]);

  // Fetch promo detail
  useEffect(() => {
    const fetchPromoAsync = async () => {
      const { data } = await agent.Promos.detail(Number(id));
      setPromo(data);
    };
    !promo && fetchPromoAsync();
  }, [id, promo]);
  //#endregion

  //#region RENDER
  if (instoreBasketActive) return <Redirect to="/" />;
  if (crossPromoBlocked) return <Redirect to="/basket" />;

  return (
    <main className="relative min-h-[50vh] pb-8 w-full">
      {status !== "idle" ? (
        <div className="min-h-[80vh] flex items-center justify-center">
          <LoadingSpinner />
        </div>
      ) : order_code ? (
        <Fragment>
          <PageHeader
            title={
              t("rituals.availableItems") +
              (promo?.code ? ` ${promo.code}` : "")
            }
          />

          <div className="text-right">
            <p>{t("rituals.myOriginalOrder")}</p>
            <p>
              <b>{order_code}</b>
            </p>
          </div>

          <ItemContainer items={backOrderItems} newOrder={false} />
        </Fragment>
      ) : (
        <h1>{t("rituals.noOriginalOrderFoundForThisPromo")}...</h1>
      )}
    </main>
  );
  //#endregion
}
